<button
  class="btn-menu flex justify-content-space-between"
  mat-stroked-button
  [matMenuTriggerFor]="optionMenu"
>
  <div class="flex align-itens-center justify-content-center">
    <mat-icon *ngIf="!!icon" class="icon-select">{{ icon }}</mat-icon>
    {{ selectedOption ? selectedOption.text : placeholder }}
  </div>
  <mat-icon class="icon-dropdown">arrow_drop_down</mat-icon>
</button>

<mat-menu #optionMenu="matMenu">
  <button
    mat-menu-item
    class="option-menu"
    *ngFor="let option of optionsList"
    (click)="changeSelection(option)"
  >
    <mat-icon
      [style.visibility]="
        selectedOption?.value === option.value ? 'visible' : 'hidden'
      "
      >check</mat-icon
    >
    {{ option.text }}
  </button>
</mat-menu>